/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_Stopped_Ago_3to12mInputs */

const en_us2_onboarding_experience_stopped_ago_3to12m = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_3to12mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 to 12 months ago`)
};

const pt_br2_onboarding_experience_stopped_ago_3to12m = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_3to12mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há 3 a 12 meses`)
};

const es_419_onboarding_experience_stopped_ago_3to12m = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_3to12mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace 3 a 12 meses`)
};

const pt_pt2_onboarding_experience_stopped_ago_3to12m = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_3to12mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há 3 a 12 meses`)
};

const fr_fr2_onboarding_experience_stopped_ago_3to12m = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_3to12mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il y a 3 à 12 mois`)
};

const de_de2_onboarding_experience_stopped_ago_3to12m = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_3to12mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor 3 bis 12 Monaten`)
};

const it_it2_onboarding_experience_stopped_ago_3to12m = /** @type {(inputs: Onboarding_Experience_Stopped_Ago_3to12mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 3 a 12 mesi fa`)
};

/**
* | output |
* | --- |
* | "3 to 12 months ago" |
*
* @param {Onboarding_Experience_Stopped_Ago_3to12mInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_stopped_ago_3to12m = /** @type {((inputs?: Onboarding_Experience_Stopped_Ago_3to12mInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_Stopped_Ago_3to12mInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_stopped_ago_3to12m(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_stopped_ago_3to12m(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_stopped_ago_3to12m(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_stopped_ago_3to12m(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_stopped_ago_3to12m(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_stopped_ago_3to12m(inputs)
	return en_us2_onboarding_experience_stopped_ago_3to12m(inputs)
});
export { onboarding_experience_stopped_ago_3to12m as "onboarding.experience_stopped_ago.3to12m" }